import { Box, Button, Grid, Link, Typography } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import { useParams, Link as RouterLink, useHistory } from "react-router-dom";
import relatorioService from "../../services/relatorioService";
import VisaoLogo from "./VisaoLogo";

import VisaoVisualizacao from "./VisaoVisualizacao";

const VisualizarRelatorio = (props) => {
    const history = useHistory();
    const { id } = useParams();
    const [relatorio, setRelatorio] = useState(null);
    const [is_printing, setIsPrinting] = useState(false);

    useEffect(() => {
        if (is_printing) {
            window.print();
        }
    }, [is_printing]);

    window.onafterprint = () => {
        setIsPrinting(false);
    };
    useEffect(async () => {
        const res = await relatorioService.getRelatorioVisualizacao(id);
        setRelatorio(res);
    }, [id]);

    return (
        <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="center"
        >
            <Box
                marginTop="1rem"
                width="80rem"
                maxWidth="95vw"
                marginBottom="1rem"
                minHeight="40rem"
            >
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid
                        className="noPrint"
                        container
                        direction="row"
                        justifyContent="space-between"
                        item
                        xs={12}
                        style={{ paddingBottom: "1rem" }}
                    >
                        <Button
                            color="secondary"
                            startIcon={<ArrowBack />}
                            size="small"
                            onClick={(e) => history.push("/relatorios")}
                        >
                            Voltar para Relatórios de crédito
                        </Button>
                        <Button
                            color="secondary"
                            size="small"
                            onClick={(e) => setIsPrinting(true)}
                        >
                            Imprimir
                        </Button>
                    </Grid>
                    <Grid
                        className="noPrint"
                        item
                        xs={12}
                        style={{ paddingBottom: "1.5rem" }}
                    >
                        {is_printing ? (
                            <></>
                        ) : (
                            <VisaoLogo
                                relatorio={relatorio}
                                is_printing={is_printing}
                            ></VisaoLogo>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        {relatorio != null && (
                            <VisaoVisualizacao
                                relatorio={relatorio}
                                is_printing={is_printing}
                            />
                        )}
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default VisualizarRelatorio;
